import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Page } from '../components'
import { WKVisible } from '../components/wk'
import '../css/page/MessagePage.css'
import { Tab, NewSystem, My } from '../components/message'
import { fixBackContentEmpty, getAccessToken, isLZWKAPP } from '../utils'


class MessagePage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            systemMsgs: null,
            myMsgs: null,
        }
    }
    componentDidMount () {
        fixBackContentEmpty()
        document.title = '我的消息'
        this.props.dispatch({
            type: 'WK_INIT_BOTTOM_BAR',
            payload: {
                selectType: 'consult',
                consultCount: 0,
            }
        })
        if (!isLZWKAPP()) {
            Promise.all([this.fetchSystemMsgs(), this.fetchMyMsgs()])
            .then(res => {
                this.setState({
                    systemMsgs: res[0].data.data.messages,
                    myMsgs: res[1].data.data.message_list,
                })
            })
        } else {
            Promise.all([this.fetchSystemMsgs()])
            .then(res => {
                this.setState({
                    systemMsgs: res[0].data.data.messages
                })
            })
        }
    }
    fetchSystemMsgs () {
        //加上时间戳 解决查看消息后 返回接口缓存问题
        return axios.get(`/api/messages/message/my?t=${new Date().getTime()}`)
    }
    fetchMyMsgs () {
        let access_token = getAccessToken()
        return window.axiosMsg.get('/msg/list', {params: {
            token: access_token
        }})
    }
    render() {
        return (
            <Page>
                <div className="wk-inner-page message-page" style={{paddingTop: isLZWKAPP() ? 0 : '55px'}}>
                    <WKVisible create={!isLZWKAPP()}>
                        <Tab routeTab={this.props.params.tab} myMsgs={this.state.myMsgs} />
                    </WKVisible>
                    <NewSystem systemMsgs={this.state.systemMsgs} tabId={this.props.tabId} />
                    <WKVisible create={!isLZWKAPP()}>
                        <My myMsgs={this.state.myMsgs} tabId={this.props.tabId} />
                    </WKVisible>
                </div>
            </Page>
        )
    }
}


export default connect(state => ({
    tabId: state.component.wkTab.selectId,
    account: state.account,
}))(MessagePage)



// WEBPACK FOOTER //
// ./src/pages/MessagePage.js